import React from 'react'
import { BreastCancerPrsLink, Title } from './styles'
import { BreastCancerPrs } from '../breastCancerPrs'
import { Divider, Inline, Stack } from '~/styles'
import { message } from '~/services'
import { usePatient } from '~/context'
import { useFetchBreastCancerPRS } from '~/hooks'
import { capitalizeOnlyFirstWord } from '~/utils'
import { ANALYTICAL_MODELS_PATH, DEFAULT_PATH } from '~/constants'
import { IconComponent } from '~/assets/icons/component'

export const BreastCancerPrsSummary = (): JSX.Element => {
  const { patient } = usePatient()
  const { data } = useFetchBreastCancerPRS({ pathParams: { patientId: String(patient.id) } })

  if (!data) return <></>

  return (
    <>
      <Divider marginTop="1.5rem" marginBottom="1.5rem" />

      <Stack width="100%" alignItems="flex-start" spacing="0.5rem">
        <Inline width="100%" justifyContent="space-between">
          <Title>{capitalizeOnlyFirstWord(message('analyticalModels.genomic_risk_score'))}</Title>
          <BreastCancerPrsLink
            to={`/${DEFAULT_PATH}/${ANALYTICAL_MODELS_PATH}/${patient.medicalRecord}`}
            state="breastCancerPrs"
          >
            Ver detalhes
            <IconComponent iconsize={11} name="externalLink" />
          </BreastCancerPrsLink>
        </Inline>

        <BreastCancerPrs prs={data} />
      </Stack>
    </>
  )
}
